import { render, staticRenderFns } from "./VisualChart.vue?vue&type=template&id=0f128809&scoped=true"
import script from "./VisualChart.vue?vue&type=script&lang=js"
export * from "./VisualChart.vue?vue&type=script&lang=js"
import style0 from "./VisualChart.vue?vue&type=style&index=0&id=0f128809&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f128809",
  null
  
)

export default component.exports